<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
        <div class="container">
            <div class="page-banner-content">
                <h1>Commerce Department</h1>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li>Departments</li>
                    <li>Department of Commerce</li>
                </ul>
            </div>
        </div>
    </div>
    <!--End Page Banner-->

    <!--Start Courses Details Area-->
    <div class="courses-details-area pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="courses-details">
                        <div class="courses-card">
                            <h2>Degree Offered</h2>
                        </div>
                        <div class="description">
                            <div class="container p-0">
                                <nav>
                                    <div class="nav nav-tabs d-flex justify-content-between" id="nav-tab"
                                        role="tablist">
                                        <button style="width: 50%;" class="nav-link active" id="nav-overview-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-overview" type="button" role="tab"
                                            aria-controls="nav-overview" aria-selected="true">Bachelor of Commerce
                                            (B.Com)
                                        </button>

                                        <button style="width: 50%;" class="nav-link" id="nav-curriculum-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-curriculum" type="button"
                                            role="tab" aria-controls="nav-curriculum" aria-selected="false">Master of
                                            Commerce (M.Com)
                                        </button>
                                    </div>
                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="nav-overview" role="tabpanel"
                                        aria-labelledby="nav-overview-tab">
                                        <div class="overview">
                                            <div class="learn">
                                                <h3>Overview</h3>
                                                <p>The Bachelor of Commerce (B.Com) is a three-year undergraduate
                                                    program focusing on commerce, finance, and business studies. It
                                                    equips students with foundational knowledge in accounting,
                                                    economics, and management, making them industry-ready.
                                                </p>
                                            </div>
                                            <div class="learn">
                                                <h3>What you will learn?</h3>
                                                <p>The Bachelor of Commerce (B.Com.) is a 3-year undergraduate degree
                                                    focusing on commerce, accounting, finance, business law, economics,
                                                    taxation, and management. It builds foundational knowledge essential
                                                    for business and financial sectors.</p>
                                                <ul>
                                                    <li>Principles of Accounting and Financial Management.</li>
                                                    <li>Business Economics and Business Law.</li>
                                                    <li>Corporate and Cost Accounting.</li>
                                                    <li>Income Tax, GST, and Auditing.</li>
                                                    <li>Management Principles and Human Resource Management.</li>
                                                    <li>Banking, Insurance, and Financial Markets.</li>
                                                    <li>E-Commerce and Information Systems.</li>
                                                    <li>Business Communication and Statistics.</li>
                                                </ul>

                                            </div>
                                            <div class="overview-box">
                                                <h4>Learning Outcome</h4>
                                                <ul>
                                                    <li>Gain a strong understanding of financial principles and business
                                                        operations.</li>
                                                    <li>Develop analytical and decision-making skills.</li>
                                                    <li>Understand taxation, accounting standards, and auditing
                                                        practices.</li>
                                                    <li>Interpret and analyze economic and financial data.</li>
                                                    <li>Management Principles and Human Resource Management.</li>
                                                    <li>Communicate effectively in a professional business environment.
                                                    </li>
                                                    <li>Prepare for higher studies like M.Com, MBA, CA, CS, CMA, etc.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="overview-box">
                                                <h4>Career Opportunities</h4>
                                                <ul>
                                                    <li>Accountant / Tax Consultant
                                                    </li>
                                                    <li>Financial Analyst / Investment Banker
                                                    </li>
                                                    <li>Auditor / Internal Auditor
                                                    </li>
                                                    <li>Banking & Insurance Officer
                                                    </li>
                                                    <li>Business Executive / Analyst
                                                    </li>
                                                    <li>Company Secretary (after additional qualification)
                                                    </li>
                                                    <li>Entrepreneur / Business Manager
                                                    </li>
                                                    <li>Government Jobs (UPSC, SSC, etc.)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="nav-curriculum" role="tabpanel"
                                        aria-labelledby="nav-curriculum-tab">
                                        <div class="curriculum">
                                            <div class="overview">
                                                <div class="learn">
                                                    <h3>Overview</h3>
                                                    <p>The Master of Commerce (M.Com) is a two-year postgraduate course
                                                        that offers advanced study in commerce, finance, and business
                                                        management. It helps students build expertise in areas like
                                                        accounting, economics, taxation, and corporate governance.
                                                        <br />
                                                        <strong>Subject Includes: </strong>ABST (Accountancy and
                                                        Business Statistics),EAFM (Economic Administration and Financial
                                                        Management)
                                                    </p>
                                                </div>
                                                <div class="learn">
                                                    <h3>What you will learn?</h3>
                                                    <p>Master of Commerce (M.Com.) is a two year postgraduate degree
                                                        focused on commerce, accounting, management, and economics. It
                                                        provides in-depth knowledge for students aiming for careers in
                                                        business, finance, and academics.</p>
                                                    <ul>
                                                        <li>Advanced Accounting and Financial Management.</li>
                                                        <li>Business Economics and Corporate Governance.</li>
                                                        <li>Strategic Management and Marketing.</li>
                                                        <li>Research Methodology and Business Statistics.</li>
                                                        <li>Taxation Laws (Direct and Indirect).</li>

                                                        <li>International Business and Trade.</li>
                                                        <li>E-Commerce and Business Technology.</li>
                                                        <li>Financial Markets and Institutions.</li>
                                                        <li> Human Resource Management.</li>
                                                        <li>Dissertation/Project Work.</li>
                                                    </ul>

                                                </div>
                                                <div class="overview-box">
                                                    <h4>Learning Outcome</h4>
                                                    <ul>
                                                        <li>Gain a deep understanding of commerce and financial systems.
                                                        </li>
                                                        <li>Develop analytical and problem-solving skills.</li>
                                                        <li>Understand business regulations, ethics, and legal
                                                            frameworks.</li>
                                                        <li>Ability to conduct independent research and interpret
                                                            financial data.</li>
                                                        <li>Prepare for professional exams like CA, CS, CFA, etc..</li>
                                                        <li>Strengthen communication, leadership, and strategic
                                                            decision-making abilities.
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="overview-box">
                                                    <h4>Career Opportunities</h4>
                                                    <ul>
                                                        <li>Finance & Accounting: Accountant, Auditor, Financial
                                                            Analyst, Tax Consultant
                                                        </li>
                                                        <li>Banking & Insurance: Investment Banker, Bank Officer,
                                                            Insurance Advisor
                                                        </li>
                                                        <li>Corporate Sector: Business Analyst, HR Manager, Marketing
                                                            Executive
                                                        </li>
                                                        <li> Education & Research: Lecturer, Research Analyst, PhD
                                                            Scholar
                                                        </li>
                                                        <li> Government Jobs: UPSC, SSC, Public Sector Banks, etc.
                                                        </li>
                                                        <li>Entrepreneurship: Start and manage your own business
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4" style="display: none;">
                    <div class="related-download">
                        <h3>Related Links</h3>
                        <ul>
                            <li><a href="fees.html"><i class="flaticon-writing-tool"></i>Fees Structure</a></li>
                            <li><a href="eligibility.html"><i class="flaticon-writing-tool"></i>Eligiblity
                                    Criteria</a>
                            </li>
                            <li><a href="../about/campus.html"><i class="flaticon-writing-tool"></i>Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--End Courses Details Area-->

    <!-- Start Bottom Connect Area -->
    <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <router-link to="/syllabus" class="default-btn btn">Syllabus<i
                            class="flaticon-next"></i></router-link>
                    <router-link to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "CommerceDeptView"
};
</script>
